import srk from "../../assets/images/about/SRK.jpg";
import { Box, Stack, Typography } from "@mui/material";
const History = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0" }}
      >
        <Typography
          variant="body1"
          textAlign={"justify"}
          p={{
            xs: 1,
            sm: 5,
            margin: "auto",
          }}
          fontSize={"1rem"}
        >
          <img
            src={srk}
            style={{ float: "left", margin: "5%" }}
            alt="History"
          />
          Late Shri Shankarrao Kanitkar founded the Progressive Education
          Society in 1934 with a great foresight. He was the fountain head of
          inspiration to members who joined hands with him in implementing the
          idea of starting a new era of education system in Pune. He was a
          strict disciplinarian, and an exemplary teacher. He was forthright,
          straightforward and a perfect educationist to the core.
          <span
            style={{
              display: "block",
              marginTop: 16,
              marginBottom: 16,
              fontWeight: "bold",
            }}
          >
            PROGRESSIVE EDUCATION SOCIETY(PES)
          </span>
          Progressive Education Society is a reputed and distinguished
          educational institution in Maharashtra. Honorable, Late Shankarrao
          Kanitkar, along with his selfless dedicated team of teachers known for
          the highest moral values, laid the foundation of the Society on the
          auspicious day of Akshay Tritiya on 16thMay, 1934 in Pune. With their
          untiring efforts and sacrifice built-up reputation of all its
          institutions over a period of time all over Maharashtra.
          <br />
          <span>
            The remarkable two words 'Progressive' and 'Modern' were the terms
            used in 1934 by Late Shankarraoji Kanitkar and his colleagues to
            demarcate the dreams and future road map of Progressive Education
            Society. The inclusion of these words was certainly with some noble
            intentions, which serves as a bright beacon for P.E. Society to
            follow with determination. They highlight the aims and objects of
            this reputed educational institution.
          </span>
          <br />
          <span>
            P.E Society runs 56 educational institutions, which include
            pre-Primary, Primary, Secondary, Higher Secondary School and
            colleges under various faculties like Arts, Science and Commerce,
            Engineering, Pharmacy, Management, Computer Science, Information
            Technology and Law etc. which have earned the reputation for
            imparting quality education under the able leadership of Dr Gajanan
            Ekbote, Chairman P.E.Society.
          </span>
          <br />
          <span>
            The Institute is committed to providing a strong foundation and
            building competencies to make complete business leaders out its
            students.
          </span>
        </Typography>
      </Stack>
    </Box>
  );
};

export default History;
